import { DialogDepositModule } from './../../shared/components/dialog-deposit/dialog-deposit.module';
import { TrackingDirectiveModule } from '@toro/common/shared/directives';
import { DialogYoutubeModule } from './../../shared/components/dialog-youtube/dialog-youtube.module';
import { FooterModule, SvgIconModule, HubNavModule } from '@toro/common/shared/components';
import { TransferQuestionsModule } from './../../shared/components/transfer-questions/transfer-questions.module';
import { AccountTypeModule } from './../../shared/components/account-type/account-type.module';
import { TransferComponent } from './transfer.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MainTransferQuestionModule } from '@hub-workspace/apps/logged-home/src/app/shared/components/main-transfer-question/main-transfer-question.module';
import { ActiveAccountTransferModule } from '@hub-workspace/apps/logged-home/src/app/shared/components/transfer-category/active-account/active-account-transfer.module';
import { OpenAccountTransferModule } from '@hub-workspace/apps/logged-home/src/app/shared/components/transfer-category/open-account/open-account-transfer.module';

@NgModule({
  declarations: [
    TransferComponent,
  ],
  imports: [
    CommonModule,
    AccountTypeModule,
    MainTransferQuestionModule,
    TransferQuestionsModule,
    FooterModule,
    DialogYoutubeModule,
    SvgIconModule,
    HubNavModule,
    TrackingDirectiveModule,
    DialogDepositModule,
    ActiveAccountTransferModule,
    OpenAccountTransferModule,
  ]
})
export class TransferModule { }
